export const FFMEPG_BASE = "https://unpkg.com/@ffmpeg/core@0.12.6/dist/umd"